var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03895 6.298H6.80295V16H5.03895V6.298ZM10.8908 14.544C10.9935 14.5533 11.1288 14.5627 11.2968 14.572C11.4648 14.572 11.6935 14.572 11.9828 14.572C13.1682 14.572 14.0502 14.2733 14.6288 13.676C15.2168 13.0693 15.5108 12.2247 15.5108 11.142C15.5108 10.0407 15.2262 9.196 14.6568 8.608C14.0875 8.02 13.2055 7.726 12.0108 7.726C11.4882 7.726 11.1148 7.74 10.8908 7.768V14.544ZM17.3588 11.142C17.3588 11.982 17.2282 12.7147 16.9668 13.34C16.7055 13.956 16.3322 14.474 15.8468 14.894C15.3708 15.3047 14.7922 15.6127 14.1108 15.818C13.4388 16.014 12.6922 16.112 11.8708 16.112C11.4788 16.112 11.0355 16.0933 10.5408 16.056C10.0462 16.028 9.57484 15.9627 9.12684 15.86V6.438C9.57484 6.33533 10.0508 6.27 10.5548 6.242C11.0588 6.214 11.5068 6.2 11.8988 6.2C12.7108 6.2 13.4528 6.298 14.1248 6.494C14.7968 6.68067 15.3708 6.97933 15.8468 7.39C16.3322 7.79133 16.7055 8.30467 16.9668 8.93C17.2282 9.546 17.3588 10.2833 17.3588 11.142Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.0b24b7fd.svg";
export { ForwardRef as ReactComponent };